
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CategoryUpdateResource,
} from '../models';
import {
    CategoryUpdateResourceFromJSON,
    CategoryUpdateResourceToJSON,
} from '../models';

export interface AcceptPrimaryJobCategoryRequest {
    accessToken: string;
}

export interface AcceptSecondaryJobCategoryRequest {
    accessToken: string;
}

/**
 * 
 */
export class JobCategoryUpdateApi extends runtime.BaseAPI {

    /**
     * Accepts the primary job category for the user
          */
    async acceptPrimaryJobCategoryRaw(requestParameters: AcceptPrimaryJobCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CategoryUpdateResource>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling acceptPrimaryJobCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CategoryUpdateResource>({
            path: `/profile/public-api/category-update/primary/{accessToken}/accept`.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CategoryUpdateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Accepts the primary job category for the user
          */
    async acceptPrimaryJobCategory(requestParameters: AcceptPrimaryJobCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CategoryUpdateResource> {
        const response = await this.acceptPrimaryJobCategoryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Accepts the secondary job category for the user
          */
    async acceptSecondaryJobCategoryRaw(requestParameters: AcceptSecondaryJobCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CategoryUpdateResource>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling acceptSecondaryJobCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CategoryUpdateResource>({
            path: `/profile/public-api/category-update/secondary/{accessToken}/accept`.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CategoryUpdateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Accepts the secondary job category for the user
          */
    async acceptSecondaryJobCategory(requestParameters: AcceptSecondaryJobCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CategoryUpdateResource> {
        const response = await this.acceptSecondaryJobCategoryRaw(requestParameters, initOverrides);
        return response._data;
    }

}
